import { useMemo, useState } from "react";
import { getRealizadoPorProjeto } from "../../api";
import RealizadoLayout from "../../components/gestaoRealizado/RealizadoLayout";
import {
  ANO_ATUAL, AvisoErro, BarraFiltros, Card, Carregando, MESES, Seletor, Vazio,
  estiloTabela, formatValor, opcoesAno, opcoesEmpresa, useCarregar, useTema,
} from "../../components/gestaoRealizado/comum";

// Faturamento realizado por projeto × mês de competência — mesma granularidade do orçado
// (Ano | Mês | Empresa | Projeto | GP). Todo faturamento do formulário é Backlog.

const FONTES = [
  { value: "solicitacoes", label: "Solicitado (formulário de NF)" },
  { value: "competencias", label: "Competências controladas" },
];

export default function FaturamentoProjetoRealizado() {
  const [isLight, setIsLight, C] = useTema();
  const [ano, setAno] = useState(ANO_ATUAL);
  const [fonte, setFonte] = useState("solicitacoes");
  const [empresa, setEmpresa] = useState("");
  const [busca, setBusca] = useState("");
  const { dados, carregando, erro } = useCarregar(() => getRealizadoPorProjeto(ano, fonte, empresa), [ano, fonte, empresa]);
  const T = estiloTabela(C);

  const linhas = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    return (dados?.linhas || []).filter((l) => !termo || l.projeto.toLowerCase().includes(termo) || l.gps.join(" ").toLowerCase().includes(termo));
  }, [dados, busca]);
  const totais = MESES.map((_, i) => linhas.reduce((a, l) => a + l.meses[i], 0));
  const semDepara = linhas.filter((l) => !l.mapeado).length;

  return (
    <RealizadoLayout titulo="Faturamento por projeto" isLight={isLight} setIsLight={setIsLight}>
      <BarraFiltros>
        <Seletor C={C} rotulo="Ano" value={ano} onChange={(v) => setAno(Number(v))} opcoes={opcoesAno} />
        <Seletor C={C} rotulo="Fonte" value={fonte} onChange={setFonte} opcoes={FONTES} />
        <Seletor C={C} rotulo="Empresa" value={empresa} onChange={setEmpresa} opcoes={opcoesEmpresa} />
        <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 11, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}>
          Buscar
          <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Projeto ou GP" style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 10px", fontSize: 13, color: C.text, minHeight: 36, boxSizing: "border-box" }} />
        </label>
      </BarraFiltros>
      <AvisoErro C={C}>{erro}</AvisoErro>

      {carregando && !dados ? <Carregando C={C} /> : (
        <Card
          C={C}
          titulo={`${linhas.length} projeto(s) · ${FONTES.find((f) => f.value === fonte).label}`}
          subtitulo={semDepara ? `${semDepara} nome(s) ainda sem de-para para o cadastro de projetos (em itálico)` : "Todos os projetos com de-para"}
        >
          {linhas.length === 0 ? <Vazio C={C}>Nenhum valor no período.</Vazio> : (
            <div style={{ ...T.wrap, maxHeight: "70vh" }}>
              <table style={{ ...T.table, minWidth: 1300 }}>
                <thead>
                  <tr>
                    <th style={T.th}>Projeto</th>
                    <th style={T.th}>Empresa</th>
                    {MESES.map((m) => <th key={m} style={{ ...T.th, ...T.thNum }}>{m}</th>)}
                    <th style={{ ...T.th, ...T.thNum }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {linhas.map((l) => (
                    <tr key={`${l.projetoId || l.projeto}-${l.empresa}`}>
                      <td style={{ ...T.td, fontStyle: l.mapeado ? "normal" : "italic", maxWidth: 260 }} title={l.gps.length ? `GP: ${l.gps.join(", ")}` : undefined}>
                        {l.projeto}
                      </td>
                      <td style={T.td}>{l.empresa || "—"}</td>
                      {l.meses.map((v, i) => <td key={i} style={{ ...T.td, ...T.tdNum }}>{formatValor(v)}</td>)}
                      <td style={{ ...T.td, ...T.tdNum, fontWeight: 700 }}>{formatValor(l.total)}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={2} style={{ ...T.td, ...T.total }}>Total</td>
                    {totais.map((v, i) => <td key={i} style={{ ...T.td, ...T.tdNum, ...T.total }}>{formatValor(v)}</td>)}
                    <td style={{ ...T.td, ...T.tdNum, ...T.total }}>{formatValor(totais.reduce((a, b) => a + b, 0))}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Card>
      )}
    </RealizadoLayout>
  );
}
